import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { HowItWorks } from './components/HowItWorks';
import { Features } from './components/Features';
import { UseCases } from './components/UseCases';
import { Security } from './components/Security';
import { CTASection } from './components/CTASection';
import { LogoScroll } from './components/LogoScroll';
import { Footer } from './components/Footer';
import { CookiesPolicy } from './pages/CookiesPolicy';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { TermsConditions } from './pages/TermsConditions';
function HomePage() {
  return <>
      <Navbar data-id="element-0" />
      <Hero data-id="element-1" />
      <HowItWorks data-id="element-2" />
      <Features data-id="element-3" />
      <UseCases data-id="element-4" />
      <Security data-id="element-5" />
      <CTASection data-id="element-6" />
      <LogoScroll data-id="element-7" />
      <Footer data-id="element-8" />
    </>;
}
export function App() {
  return <BrowserRouter data-id="element-9">
      <div className="w-full min-h-screen bg-navy-900" data-id="element-10">
        <Routes data-id="element-11">
          <Route path="/" element={<HomePage data-id="element-13" />} data-id="element-12" />
          <Route path="/cookies" element={<CookiesPolicy data-id="element-15" />} data-id="element-14" />
          <Route path="/privacidad" element={<PrivacyPolicy data-id="element-17" />} data-id="element-16" />
          <Route path="/terminos" element={<TermsConditions data-id="element-19" />} data-id="element-18" />
        </Routes>
      </div>
    </BrowserRouter>;
}